module.exports = __webpack_public_path__ + "img/form-brillant.57006e7.webp";